<template>
    <div class="g-popup" v-show="show">
        <!-- 腾讯视频绑定 -->
        <div class="media-bind-txvideo" v-if="showVqq"
            style="display: block; height: 320px; visibility: visible; position: fixed; z-index: 9999; left: 50%; top: 50%; margin-top: -160px; margin-left: -240px;">
            <div class="dia-con">
                <div class="popup-close"><i class="ico ico-close" @click="show = false;"></i></div>
                <div class="icon-logo">
                    <img src="~Assets/img/pages/v4/txvideo.png" alt="">
                </div>
                <label>
                    <span>账号</span>
                    <input type="text" name="account" v-model="vqqParams.account"
                        placeholder="请输入腾讯视频账号，必须为QQ号">
                </label>
                <label>
                    <span>昵称</span>
                    <input type="text" name="name" v-model="vqqParams.name" placeholder="请输入腾讯视频账号名称">
                </label>
                <div class="btn-group">
                    <a href="javascript:;" class="btn-save" @click="bindVqq">绑定</a>
                    <a href="javascript:;" @click="showVqq = false;">取消</a>
                </div>
            </div>
        </div>
        <div id="ams_loginWxDiv" v-else-if="showWxBind"
            style="width: 300px; height: 460px; border: 1px solid rgb(204, 204, 204); padding: 0px 20px; margin: -231px 0px 0px -171px; position: fixed; z-index: 9999; top: 50%; left: 50%; display: block; background-color: rgb(255, 255, 255); visibility: visible;">
            <span id="ams_btn_closebtn"
                style="float: right; height: 40px; width: 40px; line-height: 36px; text-align: center; font-size: 30px; margin-right: -20px; cursor: pointer; color: rgb(102, 102, 102); font-family: Verdana, sans-serif;"
                @click="show = false">×</span>
            <div id="ams_container_wxlogin">
                <iframe :src="WXbindUrl" frameborder="0" scrolling="no" width="300px" height="400px"></iframe>
            </div>
        </div>
        <div v-else-if="showQQbind" class="popup-con login-popup-con" id="login-pop">
            <!-- style="display:block;width:1000px;height: 580px;margin: 60px auto 0;" -->
            <div class="popup-close js-close-view" @click="show = false"><i class="ico ico-close"></i></div>
            <iframe :src="qqBindUrl" frameborder="0" id="tgl-login__pop" width="622" height="600"
                scrolling="no"></iframe>
        </div>
        <div class="media-bind-kandian" v-else-if="showKandianBind">
            <img class="modify1" src="~Assets/img/pages/v4/decorate1.png">
            <img class="modify2" src="~Assets/img/pages/v4/decorate2.png">
            <img class="modify3" src="~Assets/img/pages/v4/decorate3.png">
            <div class="dia-con">
                <div class="popup-close"><i class="ico ico-close" @click="close"></i></div>
                <div class="icon-logo">
                    <img src="~Assets/img/pages/v4/tgl-logo.png" alt="TGL创作联盟">
                    <img src="~Assets/img/pages/v4/kandian_bind.png" alt="QQ看点">
                </div>
                <div class="bind-title"><span class="bind-title-text">账号绑定授权</span></div>
                <label>
                    <span>看点账号：</span>
                    <input type="text" name="account" v-model="kandianParams.account" placeholder="请填写看点账号">
                </label>
                <label>
                    <span>账户昵称：</span>
                    <input type="text" name="name" v-model="kandianParams.name" placeholder="请填写账户昵称">
                </label>
                <label>
                    <span>绑定QQ：</span>
                    <input type="text" name="name" v-model="kandianParams.qq" placeholder="请填写看点绑定QQ">
                </label>
                <label>
                    <span>绑定手机号：</span>
                    <input type="text" name="name" v-model="kandianParams.tel" placeholder="请填写绑定的手机号">
                </label>
                <p class="bind-tips">说明：以上信息请前往QQ看点号平台查询</p>
                <div class="bind-hr"></div>
                <div class="btn-group">
                    <a href="javascript:;" class="btn-save" @click="bindKandian">绑定</a>
                </div>
            </div>
        </div>
        <!-- 第三方媒体绑定 -->
        <div class="popup-con thirdparty-popup" v-else>
            <div class="popup-close" @click="close"><i class="ico ico-close"></i></div>
            <img class="decorate1" src="~Assets/img/pages/v4/decorate1.png">
            <img class="decorate2" src="~Assets/img/pages/v4/decorate2.png">
            <img class="decorate3" src="~Assets/img/pages/v4/decorate3.png">
            <iframe :src="src" frameborder="0" id="media-iframe" :style="iframeStyle" scrolling="no"></iframe>
        </div>
    </div>
</template>
<style lang="scss" scoped>
#media-iframe {
    display: block;
    margin: 60px auto 0;
}
.popup-con {
    padding: 30px 89px 50px 89px;
}
#login-pop {
    width: 622px;
    height: 605px;
    padding: 55px 0 0;
}
</style>

<script>
import {
    MediaAuth, vqqBind, WXbind, kandianBind, QQbind
} from 'Services/getData';
import {
    notifyAuthUrl
} from 'Services/config';
export default {
    // props: ['media'],
    data() {
        return {
            show: false,
            src: '',
            iframeStyle: {
                width: '1000px',
                height: '580px'
            },
            vqqParams: {
                account: '',
                name: ''
            },
            kandianParams: {
                account: '',
                name: '',
                qq: '',
                tel: ''
            },
            showVqq: false,
            showWxBind: false,
            showQQbind: false,
            showKandianBind: false,
            kandianBindUrl: '',
            WXbindUrl: '',
            qqBindUrl: ''
        }
    },
    components: {},
    mounted() {

    },
    watch: {
        show: function (val) {
            if (!val) {
                this.showVqq = false;
                this.showWxBind = false;
                this.showKandianBind = false;
                this.showQQbind = false;
            }
        }
    },
    methods: {
        async bindVqq() {
            let res = await vqqBind(this.vqqParams);
            if (res.data.code == 0) {
                this.$alert('绑定成功')
                this.$emit('bindResult');
                this.show = false;
            }
        },
        async bindKandian() {
            let res = await kandianBind(this.kandianParams);
            if (res.data.code == 0) {
                this.$alert('绑定成功')
                this.$emit('bindResult');
                this.show = false;
            }
        },
        async BindMediaIframe(media) {
            this.src = '';
            switch (media.enName) {
                case 'vqq':
                    this.showVqq = true;
                    this.show = true;
                    return;
                    break;
                case 'kandian':
                    this.showKandianBind = true;
                    this.show = true;
                    return;
                    break;
                case 'wx':
                    // 微信游戏圈绑定
                    window.bindFailure = (message) => {
                        this.show = false;
                        this.showWxBind = false;
                        alert(message)
                    };
                    window.bindSuccess = (message) => {
                        this.show = false;
                        this.showWxBind = false;
                        this.$emit('bindResult');
                        this.$alert('绑定成功');
                    };
                    this.showWxBind = true;
                    this.show = true;
                    let res = await WXbind();
                    this.WXbindUrl = res.data.data.url;
                    return;
                    break;
                case 'qq':
                    // 手Q游戏中心绑定
                    window.bindFailure = (message) => {
                        this.show = false;
                        this.showQQbind = false;
                        alert(message)
                    };
                    window.bindSuccess = (message) => {
                        this.show = false;
                        this.showQQbind = false;
                        this.$emit('bindResult');
                        this.$alert('绑定成功');
                    };
                    this.showQQbind = true;
                    this.show = true;
                    let resqq = await QQbind();
                    this.qqBindUrl = resqq.data.data.url;
                    return;
                    break;
                case 'baijiahao':
                    this.iframeStyle.width = '1200px';
                    this.iframeStyle.height = '680px';
                    break;
                default:
                    this.iframeStyle.width = '1000px';
                    this.iframeStyle.height = '580px';
                    break;
            }
            let redirectUrl = notifyAuthUrl;
            let res = await MediaAuth({
                mediaName: media.enName, redirectUrl: redirectUrl
            });
            if (res.data.code == 0) {
                if (['dayu', 'youku', 'baijiahao', 'iqiyi'].includes(media.enName)) {
                    window.open(res.data.data.url)
                } else {
                    this.show = true;
                    this.src = res.data.data.url;
                }
            } else {
                alert(res.data.info);
            }
        },
        close() {
            this.show = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.media-bind-txvideo,
.media-bind-kandian {
    width: 480px;
    height: 344px;
    background-color: #ffffff;
    border-radius: 10px;
    .popup-close {
        position: absolute;
        top: 10px;
        right: 15px;
    }
    .icon-logo {
        padding: 30px 0;
        img {
            display: block;
            width: 180px;
            margin: 0 auto;
        }
    }
    label {
        position: relative;
        display: block;
        height: 36px;
        line-height: 36px;
        padding-left: 60px;
        margin-top: 18px;
        font-size: 16px;
        width: 345px;
        margin: 18px auto 0;
        padding-left: 55px;
        span {
            position: absolute;
            left: 0;
            top: 0;
            height: 36px;
            line-height: 36px;
            width: 55px;
            color: #999;
        }
        input {
            width: 350px;
            height: 34px;
            border: 1px solid #e2e2e2;
            border-radius: 4px;
            background-color: #fff;
            font-size: 16px;
            padding: 0 10px;
            font-family: '\5fae\8f6f\96c5\9ed1';
            width: 323px;
            background-color: #f4f4f4;
            font-size: 14px;
            color: #000;
        }
    }
    .btn-group {
        text-align: center;
        padding-top: 30px;
        a {
            display: inline-block;
            width: 86px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            border: 1px solid #e2e2e2;
            border-radius: 4px;
            font-size: 14px;
            color: #999999;
            margin: 0 8px;
        }
        .btn-save,
        .cur {
            background-color: #ff9100;
            border-color: #ff9100;
            color: #fff;
        }
    }
}
.media-bind-kandian {
    font-size: 16px;
    width: 610px;
    height: 610px;
    display: block;
    visibility: visible;
    position: fixed;
    z-index: 9999;
    left: 50%;
    top: 50%;
    margin-top: -305px;
    margin-left: -305px;
    border-radius: 0;
    .modify1 {
        zoom: 0.75;
        position: absolute;
        left: 20px;
        top: -20px;
    }
    .modify2 {
        zoom: 0.75;
        position: absolute;
        left: -15px;
        bottom: -15px;
    }
    .modify3 {
        zoom: 0.75;
        position: absolute;
        right: -35px;
        bottom: -17px;
    }
    .popup-close {
        top: 15px;
        right: 20px;
    }
    .btn-group {
        padding-top: 0;
        .btn-save {
            width: 300px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 18px;
            border-radius: 0;
            background: #fd7e28;
        }
    }
    .icon-logo {
        padding: 40px 0 37px;
        text-align: center;
        img {
            display: inline-block;
            vertical-align: middle;
            width: 135px;
            margin: 0 27px;
        }
    }
    .bind-title {
        text-align: center;
        position: relative;
        &-text {
            background: #fff;
            padding: 0 17px;
            position: relative;
            z-index: 1;
        }
        &:before {
            content: '';
            height: 1px;
            position: absolute;
            top: 50%;
            left: 50%;
            width: 90%;
            transform: translateX(-50%);
            background: #f1f1f1;
        }
    }
    .bind-tips {
        text-align: center;
        margin-top: 26px;
    }
    label {
        text-align: right;
        padding-left: 130px;
        margin: 32px auto 0;
        span {
            width: 100px;
            margin-right: 30px;
            color: #3a3a3a;
        }
        input {
            border-radius: 2px;
            background: transparent;
        }
    }
    .bind-hr {
        height: 1px;
        width: 90%;
        margin: 30px auto;
        background: #f1f1f1;
    }
}
</style>
